// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sb-1";
export var stateContainer = "_sb-0";